import {useEffect, useRef, useState} from 'react'
import { motion } from "framer-motion";


import '../assets/css/liturgiaDiaria.css'
import LateralMenu from './LateralMenu.jsx';
import fetchFunc from './funcionalidades/fetchFunc.jsx'
import BoxCompleta from './BoxCompleta.jsx';

// var width_ = window.innerWidth;
// var height_ = window.innerHeight;

function formatVersiculo(text){
  text = text.replace(/(\r\n|\n|\r|\t)/gm,"")

  let letr = text.split(/\d+/g)
  let num =  text
  letr.forEach((val,i)=>{
      num = num.replace(val,"Versiculo")
  });
  
  
  num = num.split("Versiculo")

  //lineBreak: 'auto'
  num = num.map((val,i)=>{
      if (i > 0 && i < num.length-1){

          return <>
          {letr[i].length < 2 ? <span className='numberChapter' style={{marginLeft: "0%"}} 
                  key={`chapter${val}${letr[i]}`}>{val}{letr[i]}</span> : <>

              <span className='numberChapter' style={{marginLeft: "1%"}} 
                  key={`chapter${val}${letr[i]}`}>{val}{". "}</span>
                      {letr[i]}{"\n"}
          </>}
          </>
      }else{
          return '';
      }
  })

  return num
}


function setCorLit(cor){
  cor = cor.toLowerCase()
  let cores = ["verde", "branco", "vermelho", "roxo", "preto", "rosa"]
  let coresHex = [
      {   backgroundColor: "#1b922699",
          filter: "invert(31%) sepia(100%) saturate(400%) hue-rotate(75deg) brightness(92%) contrast(99%)"},
      {   backgroundColor: "#8e8e8f99",
          filter: "invert(0%) sepia(99%) saturate(3%) hue-rotate(245deg) brightness(205%) contrast(100%)"},
      {   backgroundColor: "#a8142e99",
          filter: ""},
      {   backgroundColor: "#77526b99",
          filter: "invert(11%) sepia(24%) saturate(243%) hue-rotate(265deg) brightness(129%) contrast(124%)"},
      {   backgroundColor: "#49484999",
          filter: "invert(0%) sepia(99%) saturate(3%) hue-rotate(245deg) brightness(105%) contrast(100%)"},
      {   backgroundColor: "#c1345199",
          filter: "invert(15%) sepia(99%) saturate(617%) hue-rotate(304deg) brightness(89%) contrast(106%)"},]

  for (let x=0; x<cores.length; x++){
      if(cor.indexOf(cores[x]) !== -1){
          return coresHex[x]
      }
  }
}

export const LiturgiaDiaria = ({ativaResp}) => {

  const [selectedLitgy, setSelectedLitgy] = useState('primeiraLeitura')
  const [corLiturgicaAtual, setCorLiturgicaAtual] = useState()
  const [liturgyObj, setLiturgyObj] = useState(null)

  const lateralMenu = useRef()

  useEffect(()=>{
    fetchFunc.fetchGet('https://webscrappingreact.herokuapp.com/LiturgiaDiaria')
      .then(resp => resp.json())
      .then(resp => {
              setLiturgyObj(resp)
              setCorLiturgicaAtual(setCorLit(resp["corLiturgica"][0]))
      })
  },[])
  
    return <>
        <LateralMenu ativaResp={ativaResp} ref={lateralMenu}/>
        <div className="containerPrincipal liturgiaDiaria" style={{maxHeight: "100vh"}}>
        <BoxCompleta lateralMenu={lateralMenu}/>
        <div className="containerbiblia">

          <div className="topButtons">
            <div className="titlePage">Liturgia Diária</div>

            <div className="cardSelectLeitura" style={{backgroundColor: liturgyObj ? 
        corLiturgicaAtual.backgroundColor : '#DDD'}}>
              <div className="leituraSelect" 
              style={{color: selectedLitgy === 'primeiraLeitura' ? "#E09132" : "#CCC5B9"}}
              onClick={()=>setSelectedLitgy("primeiraLeitura")}>Primeira Leitura</div> 
              <div className="leituraSelect" 
              style={{color: selectedLitgy === 'salmo' ? "#E09132" : "#CCC5B9"}}
              onClick={()=>setSelectedLitgy("salmo")}>Salmo</div>
              <div className="leituraSelect" 
              style={{color: selectedLitgy === 'evangelho' ? "#E09132" : "#CCC5B9"}}
              onClick={()=>setSelectedLitgy("evangelho")}>Evangelho</div>
            </div>

            <div className="tempoLiturgia">
              <div className="imageTempo"></div>
              <div className="textoTempoLiturgia"></div>
            </div>

            {liturgyObj ? <div className="centerView mainColorDaily">
                <div className="imageResize colorDaily" 
                style={{filter: corLiturgicaAtual.filter}}></div> 
                <div>{liturgyObj["corLiturgica"][1]}</div>
                <div className="">
                {liturgyObj[selectedLitgy][0]}
                </div>
            </div> : <></>}

          </div>

            <div className="divider"></div>

            

            {liturgyObj ?<div className="principal">
               
               
                {liturgyObj ? 
              selectedLitgy === "primeiraLeitura" ? formatVersiculo(liturgyObj[selectedLitgy][2]) : 
              selectedLitgy === "salmo" ? liturgyObj[selectedLitgy][1].split("—").map((val, index)=>{
                  return index === 0 || index === 1 ? <>{val}</> : <><br key={`br${index}`}/>{"—" + val}</>
              }) :
              formatVersiculo(liturgyObj[selectedLitgy][1]) : <></>}

            </div>: <></>}
            
        </div>

        </div>
    </>
}

export default LiturgiaDiaria;